import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { type IntervalType } from "../BookingsChart/constants";
import { type ChartVisibilityState } from "../BookingsForecast";
import { ChartDateNavigator } from "../ChartDateNavigator";
import { Button } from "@/components/ui/button";

interface BookingsChartNavigationProps {
  referenceDate: Date;
  visibility: ChartVisibilityState;
  onChartStateChange: (state: ChartVisibilityState) => void;
  intervalType: IntervalType;
  onNavigateNext: () => void;
  onNavigatePrevious: () => void;
  onResetToToday: () => void;
}

export function BookingsChartNavigation({
  referenceDate,
  visibility,
  onChartStateChange,
  intervalType,
  onNavigateNext,
  onNavigatePrevious,
  onResetToToday,
}: BookingsChartNavigationProps) {
  return (
    <div className="flex p-4 justify-end items-center gap-2 flex-wrap">
      {/* On compact screens the date navigator renders inside the chart card instead */}
      <ChartDateNavigator
        referenceDate={referenceDate}
        intervalType={intervalType}
        onNavigateNext={onNavigateNext}
        onNavigatePrevious={onNavigatePrevious}
        onResetToToday={onResetToToday}
        className="flex compact:hidden"
      />
      <Button
        variant="outline"
        onClick={() => {
          onChartStateChange(visibility === "expanded" ? "collapsed" : "expanded");
        }}
        className="w-40"
      >
        {visibility === "expanded" ? (
          <>
            <ChevronUpIcon className="h-4 w-4" /> Hide Forecast
          </>
        ) : (
          <>
            <ChevronDownIcon className="h-4 w-4" /> Show Forecast
          </>
        )}
      </Button>
    </div>
  );
}
